import { connect } from 'react-redux';
import sidebarSelectors from 'src/components/Sidebar/selectors';
import TopNavItems from './TopNav';

export default connect(sidebarSelectors)(TopNavItems);
